import template from './page.columns-block.html';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.columns-block',
    []
  )
  .component('tcColumnsBlock', {
    //tc-columns-block
    template,
    bindings: {
      me: '<',
      data: '<',
      fields: '<',
      element: '<',
      disabled: '<',
    },
    controller: function () {
      this.isFieldDisabled = (field) => {
        return !this.me || field.editBy !== this.me.type;
      };
    },
  }).name;
